<template>
  <div class="modal-content modal-maps">
    <div class="">
      <button @click="$emit('close')" type="button" data-dismiss="modal" aria-label="Close" class="close"
              style="color: #fff;width: 30px; height: 30px;opacity: .6; border-radius: 30px; font-size: 30px; background: black;position: absolute; top: 30px;  z-index: 9999; right: 20px"><span
        aria-hidden="true">×</span></button>
      <div class="">
        <div id="mapLocalization" class="mt5" style="" ></div>
      </div>
      <div class="p10 hidden" style="position: relative" >
        <vueper-slides  :autoplay="false"  ref="myCarouselMap" :touchable="true" :bullets="false" class="no-shadow ex--center-mode" :dragging-distance="70" @slide="logEvents" >
          <vueper-slide v-for="(outlet,i) in outletList" :key="i" v-bind:class="classMarginLeft(i)">
            <div slot="slideContent">
              <div  class="text-left ">
                <h4><strong> <span class="text-capitalize">{{outlet.name}} </span></strong></h4>
                <p>{{outlet.address}}</p>
                <p><strong><span class="t12">  {{formatNum(outlet.distance)}}Km </span></strong></p>
              </div>
            </div>
          </vueper-slide>
        </vueper-slides>
        <!--##############################-Silder-####################### -->
        <!--<a @click="$refs.myCarouselMap.previous()" class="left carousel-control hidden-xs" href="#" data-slide="prev"-->
           <!--style="width: 25px;">-->
          <!--<span class="glyphicon glyphicon-chevron-left"></span>-->
          <!--<span class="sr-only">{{$t('button_previous')}}</span>-->
        <!--</a>-->
        <!--<a @click="$refs.myCarouselMap.next()" class="right carousel-control hidden-xs" href="#" data-slide="next"-->
           <!--style="width: 25px;">-->
          <!--<span class="glyphicon glyphicon-chevron-right"></span>-->
          <!--<span class="sr-only">{{$t('button_next')}}</span>-->
        <!--</a>-->
      </div>
    </div>
  </div>
</template>
<script>
import { VueperSlides, VueperSlide } from 'vueperslides'
import '../../assets/css/vueperslides.min.css'
export default {
  name: 'modadddd',
  mounted () {
    var vm = this
    this.$root.$on('onCloseMap', () => {
      vm.$emit('close')
    })
  },
  props: ['outletList'],
  components: { VueperSlides, VueperSlide },
  methods: {
    classMarginLeft: function (i) {
      let cl = {}
      switch (i) {
        case 0:
          cl = {'margin-left-10': true}
          break
        case 1:
          cl = {'margin-left-20': true}
          break
        case 2:
          cl = {'margin-left-30': true}
          break
        case 3:
          cl = {'margin-left-40': true}
          break
        case 4:
          cl = {'margin-left-50': true}
          break
        default:
          cl = {'margin-left-10': true}
      }
      return cl
    },
    logEvents (eventName, params) {
      console.log(params)
      this.$root.$emit('onChangeOutlet', params.currentSlide.index)
    }
  }
}

</script>
<style >
  #mapLocalization .gm-style>div:first-child>div:nth-child(3)>div:first-child>div:nth-child(4)>div:first-child>div:first-child>div:nth-child(3){
    border: unset;
  }
 .modal-maps button.close {
    background: #0000009c !important;

  }
.modal-maps  #mapLocalization {
    /*height: 238px;*/
    width: 100%;
}

#mapLocalization {
  /*height: calc(100vh - 117px);*/
  height: calc(100vh - 10px);
}
.modal-maps .vueperslide__content{
  padding-left: 10px;
}
@media (min-width: 768px) {
  #mapLocalization {
    /*height: calc(100vh - 177px);*/
    height: calc(100vh - 60px);
  }
  .modal-maps .vueperslide__content{
    padding-left: 30px;
  }
}

.modal-maps .vueperslides__inner{
  width: 100%;
}

 .modal-maps .vueperslide {
   border: 1px solid rgba(88, 84, 84, 0.19);
   border-radius: 4px;
   width: 80% !important;
 }
.modal-maps  .vueperslide--active{
  border-top: 2px solid red;
}

 .modal-maps  .vueperslide--active{
   margin-right: 10px;
 }
 .modal-maps .vueperslide--active.margin-left-10 {
   margin-left: 20%;
 }
 .modal-maps .vueperslide--active.margin-left-20 {
   margin-left: 40%;
 }
 .modal-maps .vueperslide--active.margin-left-30 {
   margin-left: 60%;
 }
 .modal-maps .vueperslide--active.margin-left-40 {
   margin-left: 80%;
 }
 .modal-maps .vueperslide--active.margin-left-50 {
   margin-left: 100%;
 }
@media (max-width: 768px) {
  .v--modal {
    width: 100% !important;
    margin: auto !important;
  }
}
.carousel-control.left {
  top: 10px;
  margin-left: 10px !important;
  z-index: 1000;
}

.carousel-control.right {
  top: 10px;
  z-index: 1000;
  margin-right: 10px !important;
}
.carousel-control {
  width: 10px;
  color: #70a401;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/ModalMaps.vue